import React, { useState } from "react";
import PageHeading from "../../components/PageHeading";
import { useQuery, useQueryClient } from "react-query";
import categoryServices from "../../services/categories";
import { Navigate, useNavigate } from "react-router-dom";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";
import Table from "../../components/Table";
import DButton from "../../components/DButton";
import { useDisclosure } from "@chakra-ui/react";
import DModal from "../../components/DModal";
import { toast } from "react-hot-toast";
import DImage from "../../components/DImage";

const columns = [
  { Header: "رقم المعرف (ID)", accessor: "id" },
  { Header: "الاسم بالعربية", accessor: "name_ar" },
  { Header: "الاسم بالانجليزية", accessor: "name_en" },
  { Header: "صورة", accessor: "img" },
  { Header: "العمليات", accessor: "actions" },
];
const Index = ({ title }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [deleteCategoryId, setDeleteCategoryId] = useState();
  const { data, isLoading, error } = useQuery(
    ["getCategories", currentPage],
    () => categoryServices.getAllCategories(currentPage + 1),
    { staleTime: 10000, cacheTime: 10000 }
  );
  const editCategory = (id) => {
    navigate("/categories/edit/" + id);
  };
  const deleteCategory = () => {
    onClose();
    categoryServices
      .deleteCategory(deleteCategoryId)
      .then((res) => {
        toast.success("تم الحذف بنجاح");
        queryClient.refetchQueries(["getCategories"]);
      })
      .catch((err) => {
        if (err.response.status === 404) {
          toast.error("القسم غير موجود");
        } else {
          toast.error("حصل خطأ ما");
        }
      });
  };
  const getFormattedData = (data) => {
    if (data.length > 0) {
      return data.map((d) => ({
        ...d,
        img: d.img ? (
          <div className="relative w-[100px] h-[100px] mx-auto">
            <DImage src={d.img} alt={d.img} load={true} />
          </div>
        ) : (
          "-------"
        ),
        actions: (
          <div className="flex items-center justify-center gap-2">
            <DButton
              onClick={() => editCategory(d.id)}
              bgColor="secondry"
              className=" px-4 rounded-[50px_!important]"
            >
              تعديل
            </DButton>
            {d.id !== 1 && (
              <DButton
                bgColor="danger"
                className={"text-white px-4 rounded-[50px_!important]"}
                onClick={() => {
                  onOpen();
                  setDeleteCategoryId(d.id);
                }}
              >
                حذف
              </DButton>
            )}
          </div>
        ),
      }));
    }
    return [];
  };
  if (error) {
    return <Navigate to="/404" />;
  }
  return (
    <div>
      <DModal
        isOpen={isOpen}
        onClose={onClose}
        modelType="delete"
        clickHandler={deleteCategory}
        bodyText="عند حذفك لهذا السجل قد يتم حذف سجلات مرتبطة به مثل
                        المنتجات المرتبطة به - عمليات التحويل"
      />
      <PageHeading>{title}</PageHeading>
      <DCard className={`relative ${isLoading ? "min-h-[400px]" : ""}`}>
        {isLoading ? (
          <DSpinner />
        ) : (
          <Table
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalData={data.data.total}
            head={columns}
            body={getFormattedData(data.data.data)}
          />
        )}
      </DCard>
    </div>
  );
};

export default Index;
